import { TranslatedCopy } from '../../intl/TranslatedCopy';

const searchKeyOptions = [
  {
    label: new TranslatedCopy({ id: 'global.orderNumber' }).toString(),
    value: 'sapOrderNumbers'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.poNumber' }).toString(),
    value: 'purchaseOrderNumbers'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.search.select.productNumber' }).toString(),
    value: 'productCodes'
  },
  {
    label: new TranslatedCopy({ id: 'global.submittedBy' }).toString(),
    value: 'orderSubmittedBys'
  }
];

const dateRangeOptions = [
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.3' }).toString(),
    value: '3 months'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.6' }).toString(),
    value: '6 months'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.12' }).toString(),
    value: '12 months'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.18' }).toString(),
    value: '18 months'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.24' }).toString(),
    value: '24 months'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.custom' }).toString(),
    value: 'custom'
  }
];

const createSearchOption = (value, translationId) => ({
  name: translationId,
  value
});

const sortOptions = [
  ['sapOrderNumber', 'orderstatus.orderNumber'],
  ['orderType', 'global.orderType'],
  ['purchaseOrderNumber', 'orderstatus.poNumber'],
  ['paymentMethod', 'global.paymentMethod'],
  ['orderNetTotal', 'orderstatus.netTotal'],
  ['orderSubmittedBy', 'global.submittedBy'],
  ['createTimestamp', 'orderstatus.orderSubmittedDate'],
  ['orderStatus', 'orderstatus.orderStatus'],
  ['orderUnitCount', 'global.numberOfUnits'],
  ['customerRequestDate', 'global.crd']
].map(([value, translationId]) => createSearchOption(value, translationId));

export { dateRangeOptions, searchKeyOptions, sortOptions };
